"use strict";

require('bootstrap');
require('bootstrap-datepicker');
require('magnific-popup');
require('slick-carousel');
require('@fancyapps/fancybox');

!function(a){a.fn.datepicker.dates.it={days:["Domenica","Lunedì","Martedì","Mercoledì","Giovedì","Venerdì","Sabato"],daysShort:["Dom","Lun","Mar","Mer","Gio","Ven","Sab"],daysMin:["Do","Lu","Ma","Me","Gi","Ve","Sa"],months:["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],monthsShort:["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"],today:"Oggi",monthsTitle:"Mesi",clear:"Cancella",weekStart:1,format:"dd/mm/yyyy"}}(jQuery);


(function( $ ) {

	$.fn.setImg = function() {
		var obj = $(this);
		var bg = $(obj).data('img');
		$('<img/>').attr('src', bg).on('load', function() {
			$(this).remove();
			$(obj).css('background-image', 'url(' + bg + ')');
			$(obj).addClass('loaded');
        });
	};

	$(function() {

        var menuStatus = false;
        function openMobileMenu(){
            $(".menu-toggle").click(function() {
                $(".mobile-menu").css("display", "block");
                menuStatus = true;
            });
        }
        function closeMobileMenu(){
            $(".mobile-menu__close").click(function() {
                $(".mobile-menu").css("display", "none");
                menuStatus = false;
            });
        }


        var laClasse = {
            common: {
                init: function() {
        // JavaScript to be fired on all pages


        openMobileMenu();
        closeMobileMenu();

        $('.imgToDiv').each(function(index, elem) {
            $(elem).setImg();
        });

        $(window).scroll(function(){
            if( $(window).scrollTop() > 0 ){
                $('header').addClass('scrolled');
            } else {
                $('header').removeClass('scrolled');
            }
        });





    },
    finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    }
},
page_template_page_homepage: {
    init: function() {
        // JavaScript to be fired on HOMEPAGE

        var lang = $('#site_lang').attr('data-lang');

        // RESERVATION TOP BLOCK
        $('.input-block .dp').datepicker({
            format: "dd/mm/yyyy",
            language: lang
        }).on('changeDate', function(e) {
            // `e` here contains the extra attributes
            var selectedValue = e.format(0,"dd/mm/yyyy");
            var $parent = $(this).parents('.input-block');
            $parent.find('.input-block__date').removeClass('w-error');
            var defaultValue = $parent.find('.value').attr('data-default');
            if( selectedValue != ''){
                $parent.find('.input-block__date .value').html( selectedValue );
            } else {
                $parent.find('.input-block__date .value').html( defaultValue );
            }
        });

        // Data values controls
        /*var today = new Date();
        var tomorrow = new Date();
        var afterTomorrow = new Date();
        tomorrow.setDate(today.getDate()+1);
        afterTomorrow.setDate(today.getDate()+2);*/
        $('.input-block.in .dp').datepicker('setStartDate','today');
        $('.input-block.out .dp').datepicker('setStartDate','tomorrow');

        // After selection In date set as minimum for the Out picker
        $('.input-block.in .dp').on('changeDate', function(e) {
            $('.input-block.out .dp').datepicker('setStartDate', e.format(0,"dd/mm/yyyy"));
        });

        $('.input-block.out .dp').on('changeDate', function(e) {
            $('.input-block.in .dp').datepicker('setEndDate', e.format(0,"dd/mm/yyyy"));
        });



        $(window).click(function () {
            $('.dp').hide();
            $('.ts').hide();
        });
        $('.input-block__date').click(function(event){
            $('.dp').hide();
            $('.ts').hide();
            $(this).parent().find('.dp').toggle();
            event.stopPropagation();
        });

        $('.input-block__time').click(function(event){
            $('.dp').hide();
            $('.ts').hide();
            $(this).parent().find('.ts').toggle();
            event.stopPropagation();
        });
        $('.ts ul li').click(function(event){
            var selectedValue = $(this).html();
            var $parent = $(this).parents('.input-block');
            $parent.find('.input-block__time').removeClass('w-error');
            $parent.find('.ts ul li').removeClass('active')
            $(this).addClass('active');
            var defaultValue = $parent.find('.value').attr('data-default');
            if( selectedValue != ''){
                $parent.find('.input-block__time .value').html( selectedValue );
            } else {
                $parent.find('.input-block__time .value').html( defaultValue );
            }
        });

        // Submit form
        $('.input-block.submit').click(function(event){
            event.preventDefault();
            // collect selected data & check it
            var inDate = $('.input-block.in .input-block__date .value').html();
            var inTime = $('.input-block.in .input-block__time .value').html();

            var outDate = $('.input-block.out .input-block__date .value').html();
            var outTime = $('.input-block.out .input-block__time .value').html();

            var check = true;

            if( inDate == "Seleziona" || inDate == "Select" ){
                $('.input-block.in .input-block__date').addClass('w-error');
                check = false;
            } else {
                $('.input-block.in .input-block__date').removeClass('w-error');
            }

            if( inTime == "Seleziona" || inTime == "Select" ){
                $('.input-block.in .input-block__time').addClass('w-error');
                check = false;
            } else {
                $('.input-block.in .input-block__time').removeClass('w-error');

            }

            if( outDate == "Seleziona" || outDate == "Select" ){
                $('.input-block.out .input-block__date').addClass('w-error');
                check = false;
            } else {
                $('.input-block.out .input-block__date').removeClass('w-error');

            }

            if( outTime == "Seleziona" || outTime == "Select" ){
                $('.input-block.out .input-block__time').addClass('w-error');
                check = false;
            } else {
                $('.input-block.out .input-block__time').removeClass('w-error');
            }


            function strToDateTime(str1){
                var dt1   = parseInt(str1.substring(0,2));
                var mon1  = parseInt(str1.substring(3,5))-1;
                var yr1   = parseInt(str1.substring(6,10));
                var hr1   = parseInt(str1.substring(11,13));
                var min1   = parseInt(str1.substring(14,17));
                var date1 = new Date(yr1, mon1, dt1, hr1, min1);
                return date1;
            }

            // Check on date-time
            if(inDate != "Seleziona" && inTime != "Seleziona" && inDate != "Select" && inTime != "Select"){
                var inDateTime = strToDateTime(inDate+" "+inTime) ;
            }
            if(outDate != "Seleziona" && outTime != "Seleziona" && outDate != "Select" && outTime != "Select"){
                var outDateTime = strToDateTime(outDate+" "+outTime) ;
            }

            if (inDateTime > outDateTime){
                check = false;
            }

            // Add check if datetime is previous of actual timestamp
            var now = new Date(); 
            if (inDateTime < now){
                check = false;
            }



            if (check == true){
                $('.error-alert').css('visibility','hidden');
                var url = 'https://www.milanairports-shop.com/' + lang + '/search/parking?product=PARK&airport=BGY&checkInDate='+inDate+'&checkInTime='+inTime+'&checkOutDate='+outDate+'&checkOutTime='+outTime;
                if (typeof ga === 'function') {
                    ga('send', 'event', 'Richiesta prenotazione', 'Form homepage');
                }
                window.open(url, '_blank');
            } else {
                $('.error-alert').css('visibility','visible');
            }





        });


        // ADD COLOR TO BENEFITS BLOCKS
        $('.benefit').each(function(){
            var color = $(this).attr('data-color');
            $(this).find('.benefit__tag').css('background-color', color);
            $(this).find('.benefit__cont').css('border-color', color);
        });

        $(".benefit").mouseenter(function() {
            var color = $(this).attr('data-color');
            $(this).find('.benefit__cont').css("background-color",color);
        }).mouseleave(function(){
            $(this).find('.benefit__cont').css("background-color","#fff");
        });

        if (window.matchMedia("(max-width: 767px)").matches) {
            /* the viewport is less than 768 pixels wide */


            $('.benefits-carousel').slick({
                dots: false,
                arrows: false,
                infinite: false,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '15px',
            });



        } else {
            //$('.options-carousel').slick('unslick');
        }




        $(window).resize(function() {});

        $(window).trigger("resize");
    },
    finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    }
},
page_template_page_tariffe: {
    init: function() {
        // JavaScript to be fired on HOMEPAGE

        if (window.matchMedia("(max-width: 767px)").matches) {
            /* the viewport is less than 768 pixels wide */
            $('.park__rateswrapper').on('show.bs.collapse', function () {

                $(this).find('.options-carousel').slick({
                    dots: false,
                    arrows: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '15px',
                });

            });



            $('.park__rateswrapper').on('hidden.bs.collapse', function () {
                $(this).find('.options-carousel').slick('unslick');
            });

        } else {
            //$('.options-carousel').slick('unslick');
        }

        $(window).resize(function() {});

        $(window).trigger("resize");
    },
    finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    }
},
page_template_page_mappa: {
    init: function() {
        // JavaScript to be fired on HOMEPAGE


        $('.map_detail__close').click(function(){
            $('body').removeClass('open');
            $('.map_detail, .map_detail_overlay').hide();
        });


        // SVG Clickable items

        $('#buttons g').click(function(event){
            var parkId = $(this).attr('id');
            if($('.map_detail[data-parkid="'+parkId+'"]').length != 0){
                $('body').addClass('open');
                $('.map_detail[data-parkid="'+parkId+'"], .map_detail_overlay').show();
            }
        });

        $('.map_detail_overlay').click(function(){
            $('body').removeClass('open');
            $('.map_detail, .map_detail_overlay').hide();
        });

        $('.gallery-carousel').slick({
            dots: true,
            arrows: false,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: '0px',
            responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true,
                    centerMode: true,
                    centerPadding: '15px'
                }
            },
            ]
        });

        // Gallery Carousel
        if (window.matchMedia("(max-width: 767px)").matches) {
            /* the viewport is less than 768 pixels wide */




        } else {
            //$('.options-carousel').slick('unslick');
        }


        $(window).resize(function() {});

        $(window).trigger("resize");
    },
    finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    }
},



};

var UTIL = {
    fire: function(func, funcname, args) {
        var fire;
        var namespace = laClasse;
        funcname = funcname === undefined ? "init" : funcname;
        fire = func !== "";
        fire = fire && namespace[func];
        fire = fire && typeof namespace[func][funcname] === "function";

        if (fire) {
            namespace[func][funcname](args);
        }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, "_").split(/\s+/), function(
          i,
          classnm
          ) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, "finalize");
      });

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
  }
};

  // Load Events
  $(document).ready(UTIL.loadEvents);





    }); // END DOC READY



$(window).on('resize', function () {
});



$(window).on('load', function () {
    $(window).trigger('resize');
});

})(jQuery);






